import IntegrationMessagesListPage from '../shared/IntegrationMessagesListPage';

const EmailOutboxMessagesListPage = () => (
    <IntegrationMessagesListPage kind="emailOutbox" />
);

export default EmailOutboxMessagesListPage;
